import { useLocalPodcast } from './podcast-provider';

export const PodcastName = () => {
  const { podcast } = useLocalPodcast();

  return <>{podcast?.title}</>
}